/** Five-tab workflow: which candidate statuses belong in each tab */
export const TAB_IDS = {
  review: 'review',
  shortlisted: 'shortlisted',
  interview: 'interview',
  selected: 'selected',
  rejected: 'rejected'
};

export const TAB_STATUS_MAP = {
  [TAB_IDS.review]: ['New', 'Cony Reviewed', 'Under Review', 'Needs Clarification', 'Hold Profile'],
  [TAB_IDS.shortlisted]: ['Shortlisted', 'Round Cleared', 'Hold Pipeline'],
  [TAB_IDS.interview]: ['Interview Scheduled'],
  [TAB_IDS.selected]: ['Selected'],
  [TAB_IDS.rejected]: ['Rejected']
};

/** All allowed pipeline status values (matches API / DB) */
export const ALL_PIPELINE_STATUSES = [
  'New',
  'Cony Reviewed',
  'Under Review',
  'Needs Clarification',
  'Hold Profile',
  'Shortlisted',
  'Round Cleared',
  'Hold Pipeline',
  'Interview Scheduled',
  'Rejected',
  'Selected'
];

export function candidatesForTab(candidates, tabId) {
  const statuses = TAB_STATUS_MAP[tabId];
  if (!statuses) return [];
  const set = new Set(statuses);
  return candidates.filter((c) => set.has(c.status));
}

/** Milliseconds for active scheduled interview, or null if missing/invalid. */
export function interviewScheduledAtMs(candidate) {
  const at = candidate?.interview_summary?.active_scheduled_interview?.scheduled_at;
  if (!at) return null;
  const ms = new Date(at).getTime();
  return Number.isFinite(ms) ? ms : null;
}

/** True when scheduled start time has passed (awaiting outcome / result entry). */
export function interviewIsPastDue(interview, nowMs = Date.now()) {
  if (!interview?.scheduled_at) return false;
  const startMs = new Date(interview.scheduled_at).getTime();
  if (!Number.isFinite(startMs)) return false;
  return nowMs > startMs;
}

function compareInterviewTabCandidates(a, b, nowMs = Date.now()) {
  const aMs = interviewScheduledAtMs(a);
  const bMs = interviewScheduledAtMs(b);
  const aRank = interviewTabSortRank(aMs, nowMs);
  const bRank = interviewTabSortRank(bMs, nowMs);
  if (aRank.group !== bRank.group) return aRank.group - bRank.group;
  if (aRank.tieBreaker !== bRank.tieBreaker) return aRank.tieBreaker - bRank.tieBreaker;
  return String(a.name || '').localeCompare(String(b.name || ''), undefined, {
    sensitivity: 'base'
  });
}

/** Upcoming (soonest first), then overdue, then missing schedule. */
function interviewTabSortRank(ms, nowMs) {
  if (ms == null) return { group: 2, tieBreaker: 0 };
  if (ms >= nowMs) return { group: 0, tieBreaker: ms };
  return { group: 1, tieBreaker: -ms };
}

/** Tab list with interview tab ordered by upcoming interview time (soonest first). */
export function candidatesForTabSorted(candidates, tabId) {
  const list = candidatesForTab(candidates, tabId);
  if (tabId !== TAB_IDS.interview) return list;
  const nowMs = Date.now();
  return [...list].sort((a, b) => compareInterviewTabCandidates(a, b, nowMs));
}

export function defaultTabForNewCandidate() {
  return TAB_IDS.review;
}
